import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../components/Home.vue';
import MenuPage from '../components/Menu.vue';
import CarteBoissons from '../components/CarteBoissons.vue';
import CarteFoodtruck from '../components/CarteFoodtruck.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/menu', component: MenuPage },
  { path: '/carte', component: CarteBoissons },
  { path: '/foodtruck', component: CarteFoodtruck }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
